import { update } from '@kundinos/nanostores';

import { orderFabricsStore } from './stores';

import type { OrderFabricsValue } from './typings';

export type Params = Pick<OrderFabricsValue, 'loading' | 'loaded'>;

function setLoading(params: Params): void {
  update(orderFabricsStore, (value) => ({
    ...value,
    loading: params.loading,
    loaded: params.loaded,
  }));
}

export default setLoading;
